import moment from 'moment'

// Formatação de data para o padrão dia/mes/ano
export function formatLongToDate(data){
    return moment(data).format('DD/MM/YYYY')
}

// Formatação de data para o padrão dia/mes/ano min;seg
export function formatLongToDateHM(data){
    return moment(data).format('DD/MM/YYYY HH:mm')
}

// verifica se a data é menor que hoje
export function verificarDataMaiorHoje(data){
    const today = new Date();
    const todayS = today.toISOString().substring(0, 10);
    const todayD = new Date(todayS)
    return data.getTime() >=  todayD.getTime()
}

// pega a data em Long e retonar um long com o dia e a hora: 23:59:59
export function setHoursInDay(dateLong){
    const date = new Date(dateLong);
    date.setHours(23)
    date.setMinutes(59)
    date.setSeconds(59)

    return date.getTime()

}


// WEBPACK FOOTER //
// ./src/helpers/Data.js